import { useState } from 'react';
import { IconButton, Panel, Tooltip } from '@origo/origo-ui';
import { StackIcon } from '@phosphor-icons/react';
import { LayerListCustom } from '@origo/origo-components';
import { AREALPLANER_LAYER_NAME } from '@origo/map-context';
import styles from './MapLayersToggle.module.css';

export function MapLayersToggle() {
    const [layersOpen, setLayersOpen] = useState(false);

    return (
        <div className={styles.layersArea}>
            <Tooltip content="Kartlag" position="right" className={styles.layersToggleWrap}>
                <IconButton
                    icon={<StackIcon size={16} weight="duotone" color="var(--accent-default)" />}
                    label="Kartlag"
                    size="md"
                    active={layersOpen}
                    onClick={() => setLayersOpen((open) => !open)}
                />
            </Tooltip>
            {layersOpen && (
                <Panel
                    heading="Kartlag"
                    closable
                    onClose={() => setLayersOpen(false)}
                    className={styles.layersPanel}
                >
                    <LayerListCustom visibleLayerTitle={AREALPLANER_LAYER_NAME} />
                </Panel>
            )}
        </div>
    );
}
